module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.f721466883998665b879.svg";


//////////////////
// WEBPACK FOOTER
// D:/taile-operate/BLACK-WIDOW/ng-src/assets/fonts/glyphicons-halflings-regular.svg
// module id = ../../../../../ng-src/assets/fonts/glyphicons-halflings-regular.svg
// module chunks = styles